import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
const GatePassOutList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
        };

        deleteHolidays(
          {
            url: "/api/procurementOfficer/",
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/gatePass/?gatepassType=Out&orgId=${localStorage.getItem(
          "orgId"
        )}&&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.goodsTransferId;

    getDetailView(
      {
        url: `/api/procurementOfficer/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsTransferId=${Id}`,
      },
      (res) => {
        //console.log("Detail View",res);
        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="modal-heading-bar" style={{ width: "750px" }}>
          <div style={{ width: "750px" }}>
            <div className="text-right">
              <button type="button" onClick={() => closeModal(false)}>
                {"\u2715"}
              </button>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                {" "}
                <h2> Getpass-In Detail</h2>
              </div>
              <div className="col-md-3"></div>
            </div>
            <div className="row"> &nbsp;</div>

            {selectedData && (
              <div>
                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Date</label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.getpassDate} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Field Officer </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.employeeName} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> GetPass No </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.docNo} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> InTime</label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.inTime} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Warehouse </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.fromWarehouseName} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Getpass Type</label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.getpassType} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Getpass For </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.getpassFor} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Farmer/Employee Name </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.getPassForName} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Doc No For</label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.docNoFor} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Doc For Date </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.harvestDate} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Email Id </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.email} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Contact No </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.contactnumber} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Vehicle</label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.vehicle} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Vehicle Number </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.vehiclenumber} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Driver Name </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.vehicledrivername} </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Driver Contact No </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.drivercontactnumber} </label>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    {" "}
                    <label> Load Quantity </label>
                  </div>
                  <div className="col-md-1">
                    <label> : </label>{" "}
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label>
                      {" "}
                      {selectedData.loadQuantity}{" "}
                      {selectedData.unitAbbreviation}{" "}
                    </label>{" "}
                  </div>
                  <div className="col-md-2">
                    <label> Remark/Note </label>{" "}
                  </div>
                  <div className="col-md-1">
                    {" "}
                    <label> : </label>
                  </div>
                  <div className="col-md-3">
                    {" "}
                    <label> {selectedData.remarkNote} </label>{" "}
                  </div>
                </div>
                <div className="row">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Product Type</th>
                        <th>Product Subtype</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData.productData &&
                        selectedData.productData.map((itm, i) => {
                          return (
                            <tr key={i} className="cursor-pointer">
                              <td>{i + 1}</td>
                              <td>{itm.productTypeName}</td>
                              <td>{itm.productSubTypeName}</td>
                              <td>{itm.productName}</td>
                              <td>{itm.itemQuantity}</td>
                              <td>{itm.unitAbbreviation}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <h2> &nbsp; &nbsp;Getpass-Out Detail</h2>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Getpass-Out
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Getpass Date</th>
                            <th>Getpass No</th>
                            <th>Gate Pass For</th>
                            <th>Person / Employee / Farmer</th>
                            <th>Assigned Supervisor</th>

                            {/* <th>Edit</th> */}
                            <th>Delete</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.getpassDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.getpassFor ?? "Procurement"}</td>
                                {/* <td>{itm.contactPersonName}</td> */}
                                <td>{x.getPassForName}</td>

                                <td>{x.employeeName}</td>

                                {/* <td>
                        <button className="btn"> <i className="fas fa-edit"></i></button>
                      </td> */}
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => deleteOperation(e, x)}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GatePassOutList;
